import { AccordionContext } from "@src/lms/jelly/extensions/ui/accordion/AccordionContext";
import React, { useCallback, useEffect, useState } from "react";

interface AccordionProps {
  allowMultiOpen?: boolean;
  defaultOpen?: string[];
  children: React.ReactNode;
  onToggle?: (openIds: string[]) => void;
}

export const Accordion: React.FC<AccordionProps> = ({ allowMultiOpen, defaultOpen, children, onToggle }) => {
  const [openIds, setOpenIds] = useState<string[]>(defaultOpen ?? []);

  useEffect(() => onToggle?.(openIds), [onToggle, openIds]);

  const handleToggle = useCallback(
    (id: string, open: boolean) => {
      if (allowMultiOpen) {
        return setOpenIds((current) => [...current.filter((k) => k !== id), ...(open ? [] : [id])]);
      }

      setOpenIds(open ? [] : [id]);
    },
    [allowMultiOpen]
  );

  return (
    <AccordionContext.Provider
      value={{
        openIds: openIds,
        onToggle: handleToggle,
      }}
    >
      {children}
    </AccordionContext.Provider>
  );
};
